import {
  ImageBitmapLoader,
  CanvasTexture,
  SphereGeometry,
  MeshBasicMaterial,
  Mesh
} from 'three';

import { Util } from './Util.js'

import { HALF_HOUR } from './constants.js'

export class SphereImageTimeController {

  constructor({wid, world, dbFile, path, skip=false, restart=false}){

    this.path = path;

    this.restart = restart;
    this.skip = skip;

    fetch(dbFile).then(r => r.json()).then(j => {
      this.db = j;
    });

    // ImageBitmapLoader is important because it does the image conversion
    // in the background and does not hang the main UI thread
    this.loader = new ImageBitmapLoader();
    this.loader.setOptions( { imageOrientation: 'flipY' } );

    let g = new SphereGeometry(101, 36, 18);
    this.m = new MeshBasicMaterial({ transparent: true });
    this.o = new Mesh(g, this.m);
    g.rotateY(Math.PI / -2);
    world.scene().add(this.o);

    wid.addTickHandler(this.tickHandler.bind(this));

  }

  tickHandler(simTime, lastSimTime){

    if(!this.db){
      return;
    }

    // Find first item in metadata whos time is greater than current time
    const nextFrameInfo = this.db.find(element => {
      return Util.ms2us(element.time) > simTime.getTime();
    });

    // If there is no next frame to load don't do anything
    if(!nextFrameInfo){
      if(this.restart){
        simTime.setTime(Util.ms2us(this.db[0].time) - HALF_HOUR);
      }
      return;
    }

    // If we are time skipping and there is more than 1/2 hour skip ahead to new frame
    if(this.skip){
      if(Util.ms2us(nextFrameInfo.time) - simTime.getTime() > HALF_HOUR){
        simTime.setTime(Util.ms2us(nextFrameInfo.time));
      }
    }

    // Only update on change
    if(this.currentFrameInfo && this.currentFrameInfo == nextFrameInfo){
      return;
    }

    this.currentFrameInfo = nextFrameInfo;

    // load a resource
    this.loader.load(
      this.path + nextFrameInfo.filename,
      imageBitmap  => {
        console.log("Loaded: " + nextFrameInfo.filename);
        const texture = new CanvasTexture(imageBitmap);
        this.m.map = texture;
        this.m.needsUpdate = true;
      });
  }

}